import React from "react";
import PropTypes from "prop-types";
import Select from "components/forms/Select";
import MapaGeografico from "../../components/mapa-geografico/mapa-geografico.component";
import Ubigeo from "../../commons/ubigeo.module";
import "./vista-inicio-block-mapa.block.scss";
import { LISTA_REGIONES } from "../../data/ubigeo.data";
const default_store = [{ value: "", label: "Seleccione una región" }];
let NEW_LISTA_REGIONES = LISTA_REGIONES.filter(item => item.value !== "00");
class BlockMapa extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };
  onRegionChange(ubigeo) {
    this.navigateToRegion(ubigeo[0].value);
  }

  render() {
    let me = this;
    return (
      <div className="vista-inicio__block-mapa">
        <div className="vista-inicio__block__header">
          <i className="icon-regiones" />
          &nbsp;
          <span className="vista-inicio__block__header__text">
            Región&nbsp;&nbsp;
          </span>
          <div className="react-select-container">
            <Select
              className=""
              store={NEW_LISTA_REGIONES}
              item_default={default_store}
              onChange={me.onRegionChange}
              scope={me}
              placeholder="Seleccione una región"
            />
          </div>
        </div>
        <div className="vista-inicio__block-mapa__container">
          <MapaGeografico onRegionClick={me.navigateToRegion} scope={me} />
        </div>
        <div className="vista-inicio__block__footer">&nbsp;</div>
      </div>
    );
  }
  navigateToRegion(codigoRegion) {
    let nombreRegion = Ubigeo.getNombreRegionForUrl(codigoRegion);
    this.context.router.history.push(`./regiones?region=${nombreRegion}`);
  }
}
export default BlockMapa;
